import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef, Input, ViewChild } from '@angular/core';
import { BaseService } from '../../../base/shared/services/base.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from 'src/modules/base/services/modal.service';
import { ModalSize, SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { TranslateService } from 'src/modules/base/services/translate.service';
import { FilterService } from 'src/modules/base/services/filter.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { SearchPatientComponent } from 'src/modules/base/components/misc/searchPatient/search-patient.component';
import { DynamicPopUpComponent } from 'src/modules/base/components/data-grid/dynamic-pop-up/dynamic-pop-up.component';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { UtilitiesService } from 'src/modules/base/services/utilities.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { KeyValue } from '@angular/common';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { FilterHelperService } from 'src/modules/base/services/filter-helper.service';

@Component({
    selector: 'app-bed-management',
    templateUrl: './bed-management.component.html',
    styleUrls: ['./bed-management.component.scss'],
    standalone: false
})
export class BedManagementComponent implements OnInit {
  hasBedDetails: any[];
  hasDetailView: boolean;
  patientData: any;
  bedId: any;
  Arr: any[] = [];
  filterKey: any;
  resource: any;
  id: any;
  @Output() bindGrid: EventEmitter<any> = new EventEmitter();
  @ViewChild('kxFilter', { static: false }) kxFilter: any;
  filterParam: string = "";
  conditionArr: any[] = [];
  fields: any;
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }
  totalBeds: any;
  housekeeping_bed: any;
  occupied_bed: any;
  vacant_bed: any;
  reserved_bed: any;
  isOpen = true;
  // ─── Saved Filter State ───────────────────────────────────────────────────────
  filterAr: any[] = [];
  filterConfig: any = {};
  filterFormGroup: any;
  filterFormMapping: any;
  preferenceData: any = {};
  // ─────────────────────────────────────────────────────────────────────────────
  config = {
    "submitButton": true,
    "filterForm": true,
    "clearOnSave": false,
    "delegateSave": true,
    "setSearchPopup": false,
    "cancelRoute": '',
    "complex_search": '',
    "save_filter": false
  }
  serVal: any;
  occupiedwithhousekeeping_bed: any;
  blocked_bed: any;
  total_occupancy: number;

  constructor(
    private utilitiesService: UtilitiesService,
    private cdRef: ChangeDetectorRef,
    public baseService: BaseService,
    private router: Router,
    private aroute: ActivatedRoute,
    private alert: AlertsService,
    private modalService: ModalService,
    private translateService: TranslateService,
    private filterService: FilterService,
    private spinner: LoaderService,
    public dialogService: DialogService,
    private smartModalService: SmartModalService,
    private roleService: RolePermissionService,
    public preferenceService: PreferenceService,
    private filterHelperService: FilterHelperService
  ) {
    this.serVal = this.utilitiesService.documentClickedTarget
      .subscribe(target => {
        this.onClick(target)
      })
  }

  ngOnInit() {
    this.baseService.setTitle("Bed Management");
    this.management();
  }

  onClick(args: any) {
    if ((args.target.tagName == 'A' || args.target.tagName == 'I') && (args.target.className.includes('complex-search-pill-close') || args.target.className.includes('fa fa-angle-down'))) {
    } else {
      if (this.config.setSearchPopup) {
        this.config.setSearchPopup = false;
        this.cdRef.detectChanges();
      }
    }
  }

  management() {
    this.baseService.getResourceDef(this.aroute.snapshot.data.resource, (resourcedef: any) => {
      if (resourcedef) {
        if (this.aroute.snapshot.queryParams.hasOwnProperty("tab_0"))
          this.getResourceInfo(resourcedef.layout.find(x => x.id == this.aroute.snapshot.queryParams.tab_0).component.resource, resourcedef.layout.find(x => x.id == this.aroute.snapshot.queryParams.tab_0).component.patient_type)
        else
          this.getResourceInfo(resourcedef.layout.find(x => x.id == resourcedef.default_layout_id).component.resource, resourcedef.layout.find(x => x.id == resourcedef.default_layout_id).component.patient_type)
      }
    })
  }

  getResourceInfo(resource: any, id: any) {
    this.baseService.getResourceDef(resource, (resouceDef) => {
      if (resouceDef) {
        this.resource = resouceDef;
        this.config.complex_search = resouceDef.complex_search;
        this.config['save_filter'] = resouceDef.config?.save_filter || false;
        this.config['saveKey'] = resource + '_list_config';
        this.fields = resouceDef.fields.sort(function (a, b) { return a.order - b.order })
        this.id = id;
        this.filterAr = [];
        this.filterConfig = {};
        this.preferenceData = {};
        this.getSavedFilter();
        // this.callAPI();
        this.spinner.showSpinner();
      }
    })
  }

  displayFilter() {
    if (this.resource.filter.hasOwnProperty('default_open'))
      this.resource.filter.default_open = !this.resource.filter.default_open
  }

  resetFilter(event: any) {
    // this.callAPI();
    this.displayFilter();
    this.bindGrid.emit(event);
    this.spinner.showSpinner();
  }

  doSearch(event: any) {
    this.bindGrid.emit(event);
    this.filterParam = event;
    //added to remove duplicate filters
    this.filterParam = this.filterService.removeDuplicateKeysFromString({ "filter": this.filterParam });
    this.callAPI();
    this.displayFilter();
    this.spinner.showSpinner();
  }

  getDataFn(event: any) {
    if (event && event.type == "form" && event.obj && event.obj.form != undefined) {
      this.filterFormGroup = event.obj.form;
    } else if (event && event.type == "mapping" && event.obj && event.obj.form != undefined) {
      this.filterFormMapping = event.obj.form;
    } else if (event && event.type == "default_filter_val" && event.obj && event.obj.form) {
      this.bindGrid.emit(event.obj.form);
      this.filterParam = event.obj.form;
      this.filterParam = this.filterService.removeDuplicateKeysFromString({ "filter": Object.entries(this.filterParam).map(([a, b]) => { if (b) { return `${a}: ${b}` } }).filter(x => x != undefined).join(",").replace(" ", "") });
      this.callAPI();
      this.spinner.showSpinner();
    } else if (event && event.type == 'filter_save') {
      this.saveFilterData(event.obj);
    }
  }

  public onFilterClick(event) {
    this.spinner.showSpinner();
    this.callAPI(event);
  }

  callAPI(search?) {
    this.hasDetailView = true;
    this.filterKey = search;
    var args = {
      "args": this.resource.datasource.args.replace("!!!getterKey!!!", this.id)
    }
    if (this.filterKey != '' && this.filterKey != undefined) {
      args['search'] = this.filterKey.value;
      args["search_columns"] = this.filterKey.key;
    }

    if (this.filterParam)
      args['filter'] = this.filterParam

    this.baseService.getData(args, "", this.resource.datasource.resource, this.resource.datasource.application, this.resource.datasource.query_id).subscribe(data => {
      var result = data.resource;
      this.totalBeds = result.length;
      this.housekeeping_bed = result.filter(x => x.stage_action == "housekeeping").length;
      this.occupied_bed = result.filter(x => x.stage_action == "occupied").length;
      this.occupiedwithhousekeeping_bed = result.filter(x => x.stage_action == "occupiedwithhousekeeping").length;
      this.vacant_bed = result.filter(x => x.stage_action == "vacant").length;
      this.reserved_bed = result.filter(x => x.stage_action == "reserved").length;
      this.blocked_bed = result.filter(x => x.stage_action == "blocked").length;
      this.total_occupancy = Math.round((data.resource.filter(x => x.stage_action == "occupied").length / data.count) * 100)
      let temp1 = result.map(y => (({ ward_name, name, stage, bed_zone, stage_action, partOf,stage_action_name, id, wing_name, wing_id, ward_id, wardtype_id, wardtype_name, patient_details }) => ({ ward_name, name, partOf,stage, bed_zone, stage_action, stage_action_name, id, wing_name, wing_id, ward_id, wardtype_id, wardtype_name, patient_details }))(y))
      this._callForColors(temp1)
      // this.spinner.hideSpinner()
    })
  }
  hasPatientDetails(event: any, bed: any) {
    if (bed && bed.id) {
      this.spinner.showSpinner();
      this.bedId = bed.id;
      var args = this.resource.detail_datasource.args.replace("!!!getterKey!!!", this.bedId);
      this.Arr.push(this.bedId)
      this.baseService.getDataAsPerResource(this.resource.detail_datasource.query_id, args, this.resource.detail_datasource.resource, this.resource.detail_datasource.application).subscribe(result => {
        this.patientData = result.resource[0];
        if (result.resource?.[0]?.encounter_id)
          sessionStorage.setItem('bedManagementData', JSON.stringify(result.resource[0]))
        //this.isOpen = true;
        this.spinner.hideSpinner()
      })
    }
    this.spinner.hideSpinner()
  }

  // ─── Saved Filter Methods (delegated to FilterHelperService) ────────────────

  getTableConfig(callback: any, force?: boolean) { this.filterHelperService.getTableConfig(this, callback, force); }
  getSavedFilter(callback?: Function) { this.filterHelperService.getSavedFilter(this, callback); }
  checkFilterCondition(filter: any): boolean { return this.filterHelperService.checkFilterCondition(filter); }
  applyFilter(filter: any) { this.filterHelperService.applyFilter(this, filter); }
  saveFilterData(obj: any) { this.filterHelperService.saveFilterData(this, obj); }
  saveTableConfigData(data: any, callback: any = false, userScope?: boolean, del?: string) { this.filterHelperService.saveTableConfigData(this, data, callback, userScope, del); }
  manageFilter() { this.filterHelperService.manageFilter(this); }

  // ─────────────────────────────────────────────────────────────────────────────

  _callForColors(temp1) {
    this.spinner.showSpinner()
    var _args = { args: "" }
    this.baseService.getData(_args, "", this.resource.detail_datasource_ward.resource, this.resource.detail_datasource_ward.application, this.resource.detail_datasource_ward.query_id).subscribe((_result: any) => {
      if (_result.errCode == 0) {
        if (_result.resource.length != 0) {
          this.hasBedDetails = [...new Set(temp1.map(x => x.ward_name))].map(x => { return { ward_name: x, bedDetails: temp1.filter(q => q.ward_name == x).sort((a, b) => a.name.localeCompare(b.name)), background: (_result.resource.find(e => e.name == x) != undefined && _result.resource.find(e => e.name == x).ward_color != undefined) ? _result.resource.find(e => e.name == x).ward_color + "4a" : "#fafafa" } }).sort((a: any, b: any) => !a.ward_name ? 0 : a.ward_name.localeCompare(b.ward_name));
        } else {
          this.hasBedDetails = [...new Set(temp1.map(x => x.ward_name))].map(x => { return { ward_name: x, bedDetails: temp1.filter(q => q.ward_name == x).sort((a, b) => a.name.localeCompare(b.name)), background: '#fafafa' } }).sort((a: any, b: any) => !a.ward_name ? 0 : a.ward_name.localeCompare(b.ward_name));
        }
      } else {
        this.alert.error(_result.message)
      }
      this.spinner.hideSpinner()
    })
  }

  searchPatient(data, bedData) {
    let obj = {
      "complex_search": [
        {
          "label": "field.label.uhid",
          "key": "uhId"
        },
        {
          "label": "field.label.abha_id",
          "key": "abdm_number,healthIdNumber"
        },
        {
          "label": "field.label.telecom",
          "key": "telecom"
        },
        {
          "label": "field.label.patient_name",
          "key": "name_.text,name_.family"
        },
        {
          "label": "field.label.employee_id",
          "key": "employerDetails.employee_id"
        },
        {
          "label": "field.label.preRegistrationNo",
          "key": "preRegistrationNo"
        },
        {
          "label": "field.label.tempMrNo",
          "key": "tempMrNo"
        }
      ],
      "label": "Admit New",
      "hint": "field.hint.fieldAdmitNew",
      "type": "search",
      "datasource": {
        "application": "patient-registration",
        "resource": "patient",
        "query_id": "GET_REGISTERED_PATIENTS",
        "template": "<div class='u-search-items position-relative border-bottom pl-3 pr-3 pb-1 pt-1'><div class='u-name'>!!!patient_name!!!</div><span class='u-phone txt-13 pr-2'>!!!telecom!!!</span><span class='u-uhid txt-13'>!!!uhId!!!</span><span class='u-age txt-13 pl-2'>!!!patient_age!!!</span><span class='u-gender txt-13'>!!!patient_gender!!!</span><br><span class='u-age txt-13'>PIN-!!!address.pincode!!!</span></div>"
      },
      "fields": [
        "patient_name",
        "telecom",
        "uhId",
        "patient_age",
        "patient_gender",
        "uhId_status",
        "address.pincode"
      ],
      "remote_confirm": {
        "msg_key": "message",
        "expression": "item['valid'] == false",
        "datasource": {
          "resource": "encounter",
          "application": "adt",
          "query_id": "CHECK_IF_ALREADY_ADMITTED",
          "args": "uhId:!!!uhId!!!,status:Admitted"
        }
      },
      "conditions": [
        {
          "expression": "item['uhId_status'] == false",
          "action": "remote_confirm",
          "err_message": "UHID deactivated, cannot admit patient"
        },
        {
          "expression": "item['external_uhId']",
          "action": {
            "popup": {
              "title": "Add Patient",
              "size": "lg",
              "redirectLink": "/adt/encounter_ipAdmission/add"
            },
            "layout_type": "simple",
            "text": "Add Patient",
            "resource": "patient",
            "action_name": "external_register_patient",
            "action": "ADD",
            "application": "patient-registration"
          }
        }
      ],
      "fixLabel": {
        "popup": {
          "title": "Add Patient",
          "size": "lg",
          "redirectLink": "/adt/encounter_ipAdmission/add"
        },
        "text": "Register New Patient",
        "layout_type": "simple",
        "resource": "patient",
        "action": "add",
        "application": "patient-registration"
      },
      "datasource_details": {
        "popup": {
          "title": "Inactive Patient",
          "size": "lg",
          "redirectLink": "/appointment/add-appointment",
          "appLink": "addAppointment",
          "required_rowData": true,
          "resource": "deactivate_patient"
        },
        "text": "Inactive Patient",
        "layout_type": "simple",
        "resource": "patient",
        "filter": "uhId_status:false",
        "query_id": "GET_PAGE",
        "application": "patient-registration"
      }
    }
    let popobj = { data: obj, title: 'Search or add patient', size: DialogModalSize.Md };
    this.dialogService.open(SearchPatientComponent, popobj).afterClosed.subscribe(
      response => {
        if (response != undefined) {
          this.apiCheckForBedValidation(response,bedData,data)
        }
      });
  }


  apiCheckForBedValidation(response,bedData,data){
    let args = "patient_gender:" + response.gender_id + ",room_id:" + bedData.partOf
    this.baseService.get('VALIDATE_SAME_GENDER_ROOM', args, 'encounter', 'adt').subscribe((result) => {
        if(result.errCode != -1){
          data['action'] = "add_detail"
          this.redirectUrl(data, response, bedData)
          console.log("Response is ", response, "data is :: ", data);
        } else {
          this.alert.error(result.message)
        }
    })
  }

  confirmBooking(resource: any, value: any) {
    let obj = {
      "action": resource,
      "val": value
    }

    this.smartModalService.open(DynamicPopUpComponent, obj, obj.action.title, ModalSize.Sm).subscribe(res => {
      if (res) {
        if (res.result.errCode == 0) {
          this.callAPI()
        }
      }
    },
      err => {
        console.log("error in getting data :: ", err);
      }
    );
  }


  vacatBed(data, action) {
    let popupTitle = "";
    this.translateService.translate(action.label).subscribe(x => {
      if (x) {
        popupTitle = x;
      }
    });
    let name: string = "";
    if (action.name != undefined) {
      name = data[action.name];
    } else {
      name = "";
    }
    const dialogRef = this.modalService.confirm(popupTitle, action.message + ' ' + name + '?', ModalSize.Sm);
    dialogRef.subscribe(result => {
      if (result) {
        if (action.datasource.data != undefined) {
          var res = action.datasource.data[0];
          for (let i = 0; i < Object.keys(res).length; i++) {
            data[Object.keys(res)[i]] = res[Object.keys(res)[i]];
          }
          this.getData(data, action);
        } else {
          this.getData(data, action);
        }
      }
    },
      () => { });
  }

  getData(data, action) {
    this.baseService.action(data, action.datasource.action, action.datasource.application, action.datasource.resource).subscribe(
      (data: any) => {
        if (data.errCode == -1) {

        } else {
          this.callAPI()
        }
      })
  }

  public filterValidate(e) {
    var invalidChars = ["%"];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  public onFilter(event) {
    var valid = this.filterValidate(event);
    if (valid) {
      if (event.keyCode === 13) {
        this.callAPI();
        this.spinner.showSpinner();
      }
    }
  }

  getValue(item, hasJson) {
    if (hasJson.hasOwnProperty('type')) {
      if (hasJson.type === 'date' || hasJson.type === 'datetime') {
        return item[hasJson.name] ? new Date(item[hasJson.name]).toLocaleString() : '';
      }
      return eval(hasJson.format)(item)
    } else {
      return item[hasJson.name]
    }
  }
  toggleVisibility() {
    this.isOpen = !this.isOpen;
  }

  redirectUrl(data: any, patient: any, bedData: any) {
    this.toggleVisibility();
    if (data.action == 'add')
      this.router.navigate(["/" + data.application + "/" + data.resource + "/" + data.action], { queryParams: { key: patient[data.key], returnUrl: location.pathname } })
    else if (data.action == 'confirm')
      this.vacatBed(patient, data)
    else if (data.action == 'popup_form')
      this.searchPatient(data, patient)
    else if (data.action == 'add_detail')
      this.router.navigate(["/" + data.application + "/" + data.resource + "/add"], { queryParams: { key: patient[data.key], returnUrl: location.pathname, wing_data: JSON.stringify(bedData) } })
    else if (data.action == 'confirm_popup_form')
      this.confirmBooking(data, patient)
    else if (data.action == 'custom')
      this.customRoute(data, patient.id);
    else if(data.action == 'request_mrd_print')
      this.requestEpisodePrint(data, patient);
    else if(data.action == 'mrd_print')
      this.episodePrint(patient);
    setTimeout(() => {
      this.toggleVisibility();
    })
  }

  /**
   * Requests episode print generation for a patient's encounter.
   * Calls backend API to initiate the print document creation process.
   * 
   * @param data - Action configuration object containing action_name, application, and resource
   * @param patient - Patient object with encounter information
   * @returns void
   */
  requestEpisodePrint(data: any, patient: any) {
    this.spinner.showSpinner();
    this.baseService.action(patient, data?.action_name, data?.application, data?.resource).subscribe(
      (data: any) => {
        this.spinner.hideSpinner();
        if (data.errCode == -1) {
          console.error("Error occurred while requesting episode print.", data);
          this.alert.error(data?.message);
        } else {
          this.alert.success("Episode print requested successfully");
        }
    });
  }

  /**
   * Fetches and opens episode print document in browser PDF viewer.
   * Retrieves EMR journey document from DMS and displays in new tab.
   * 
   * @param patient - Patient object containing id, uhId, and encounter_id
   * @returns void
   * 
   * Flow:
   * - Fetches document ID from GET_EMR_JOURNEY_DOC_ID API
   * - Validates document exists, shows error if not generated
   * - Retrieves PDF blob from DMS endpoint
   * - Opens PDF in new browser tab using built-in viewer
   */
  episodePrint(patient: any) {
    this.spinner.showSpinner();
    let agrs = "id:"+patient?.id+",uhId:"+patient?.uhId+",encounterId:"+patient?.encounter_id;
    this.baseService.get("GET_EMR_JOURNEY_DOC_ID", agrs, 'mrd_print', 'mrd').subscribe(res => {
      this.spinner.hideSpinner();
      if (res.errCode != undefined && res.errCode == -1 && res.message != undefined) {
        this.alert.error(res?.message);
      }
      if (res?.errCode != undefined && res?.errCode == 0 && res?.resource?.length > 0) {
        if(!res?.resource[0]?.document_id){
          this.alert.error("Episode print is not generated for visit "+patient?.encounter_id+",click on Request Episode Print to generate the print.");
        } else {
          const url = this.baseService.getApiEndpoint("dms") + "mrd_document" + "/image-response-entity?path=" + res.resource[0].document_id;
          this.baseService.getFileByUrl(url, false).subscribe((res: any) => {
            if (res) {
              const objectUrl = URL.createObjectURL(res);
              window.open(objectUrl, '');
            }
          });
        }
      }
    });
  }

  customRoute(action, key) {
    //this will work as new capability
    if (action.route_path != undefined && action.route_path) {
      //here key is the data of the row
      this.baseService.redirectToOtherPage(action.route_path, key);
    }
    else {
      //console.log("Key ", action, key);
      var app = '';
      if (action.hasOwnProperty('application')) {
        app = action.application;
      }
      var keyForUrl = '';
      if (action.set_key != undefined && action.set_key != '') {
        keyForUrl = key[action.set_key];
      } else {
        keyForUrl = key.id ? key.id : key;//change by saurav deep for getting key
      }
      let queryParams = { key: keyForUrl };
      if (action.hasOwnProperty('query_params')) {
        let query_params = this.baseService.buildDyanamicStr(action.query_params, { data: key });
        queryParams = { ...queryParams, ...{ query_params } }
      }
      if (action.hasOwnProperty('queryParams')) {
        let banner = { banner: JSON.stringify(action.queryParams) }
        queryParams = { ...queryParams, ...banner, ...{ returnUrl: this.router.url } }
      } else {
        let returnUrl = { returnUrl: this.router.url };
        queryParams = { ...queryParams, ...returnUrl }
      }
      console.log("query Params is ", queryParams);
      let url = '';
      if (action.hasOwnProperty('redirect') && action.redirect.action != undefined) {
        if (action.redirect.action == 'modify' || action.redirect.action == 'view') {
          url = '/' + app + '/' + action.resource + '/' + key.id + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        } else if (action.redirect.action == 'list') {
          url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        } else {
          url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        }
      } else if (action.hasOwnProperty('redirectLink')) {
        action.redirectLink = action.redirectLink.indexOf('!!!') != -1 ? this.baseService.buildDyanamicStr(action.redirectLink, { data: key }) : action.redirectLink;
        url = '/' + app + '/' + action.redirectLink;
        if (action.hasOwnProperty('queryParams')) {
          this.router.navigate([url], {
            queryParams: queryParams
          });
        } else {
          this.router.navigate([url], { queryParams: queryParams });
        }
      } else {
        if (action.dependent != undefined && action.dependent) {
          if (localStorage.getItem('filterValueInForm') == null) {
            alert("Select filter first");
          }
          else {
            let a = action.key ? key[action.key] : keyForUrl;
            url = '/' + app + '/' + keyForUrl + '/' + action.resource + '/' + (action.type ? action.type : '');
            this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: a } });
          }
        }
        else {
          let c = action.key ? key[action.key] : keyForUrl;
          url = '/' + app + '/' + encodeURIComponent(c) + '/' + action.resource + '/' + (action.type ? action.type : '');
          if (action.hasOwnProperty('queryParams') || action.hasOwnProperty('query_params')) {
            let b = action.key ? key[action.key] : keyForUrl;
            if (action.hasOwnProperty('query_params')) {
              let query_params = this.baseService.buildDyanamicStr(action.query_params, { data: key });
              this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: b, data: JSON.stringify(action.queryParams), query_params: query_params } });
            } else {
              this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: b, data: JSON.stringify(action.queryParams) } });
            }
          } else
            this.router.navigate([url], { queryParams: queryParams });
        }
      }
    }

  }


  checkCondition(condition: any, data: any) {
    if (!data)
      return
    var item = new Proxy(data, {
      get: (target, prop) => {
        if (typeof prop === 'string') {
          if (prop in target) return target[prop];
          const lowerProp = prop.toLowerCase();
          const key = Object.keys(target).find(k => k.toLowerCase() === lowerProp);
          if (key) return target[key];
        }
        return target[prop];
      }
    });
    console.log("condition is :: ", condition);
    if (condition) {
      var c = [];
      for (let i = 0; i < condition.length; i++) {
        let expr = condition[i].expression.replace(/\.toLowerCase\(\)/g, "?.toLowerCase()");
        c.push(expr)
      }
      try {
        if (c.length > 1)
          return eval(c.join(" && "))
        else
          return eval(c[0])
      } catch (e) {
        console.error("Error evaluating condition:", e, c);
        return false;
      }
    } else {
      return true;
    }
  }

  detailView() {
    this.hasDetailView = true;
  }

  overView() {
    this.hasDetailView = false;
  }

  checkPermission(capability: any) {
    if (capability.hasOwnProperty("permission_required")) {
      if (capability.permission_required) {
        return this.roleService.checkAccessPermission(capability.action_name, this.resource.resource, this.resource.application)
      } else {
        return true
      }
    } else {
      return false
    }
  }

}
